/**
 * @file IconEdit Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-edit',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.5}"
  >
    <rect width="48" height="48" x="0" y="0" />
    <g
      stroke="${data.colorDesc[0]}"
      stroke-linecap="${data.strokeLinecap}"
      stroke-linejoin="${data.strokeLinejoin}"
      transform="translate(11.367996,11.118328)"
    >
      <path
        d="M16.37934 0 2 0C.89543 0 0 .89543 0 2L0 24C0 25.10457.89543 26 2 26L24 26C25.10457 26 26 25.10457 26 24L26 12.01738 26 12.01738M10.33354 16.72694 26.632.42848"
      />
    </g>
  </g>
</svg>
`
);
